import axios from 'axios'
import router from '@/router'
import defaultAtencionOfertaForm from '@/util/offerConfigurator/defaultAtencionOfertaForm.js'
import defaultPaqueteForm from '@/util/offerConfigurator/defaultPaqueteForm.js'
// import defaultOfertaForm from '@/util/offerConfigurator/defaultOfertaForm'
import { clone, objectCamelToSnakeCase, objectSnakeToCamelCase, deleteKeyNullValues, getDefaultStrDate } from '@/util/libUtil.js'
import readError from './util.js'

const state = () => ({
    isp: null,
    numeroComercial: null,
    configuratorType: 'CREATE',
    loadingTariffs: false,
    isLoadingCliente: false,
    operador: "",
    localizacion: "Península",
    isOpenConfiguratorStepper: false,
    isOpenAditionalStepper: false,
    isOpenPresetDialog: false,
    canSaveOffer: true,

    atencion: clone(defaultAtencionOfertaForm),

    paquete: clone(defaultPaqueteForm), // El paquete que se muestra en un momento concreto en el stepper

    hasAdditionals: false,
    stepperType: null,
    totalPrice: 0,
    cuotaTerminales: 0,
    selectedLocation: '',
    precioMensOtro: 0.00,

    presetPhoneNumbers: [],
    presetMainUsed: false,

    svas: [],
    tariffs: [],
    additionals: [],
    terminals: [],
    promotions: [],
    installments: [],
    installmentsLoading: false,

    cliente: null,

    paths: {
        tariffsPath: '/api/servicios/tarifas/',
        svaPath: '/api/servicios/sva/',
        additionalsPath: '/api/servicios/adicionales/',
        promotionsPath: '/api/servicios/promociones/',
        terminalsPath: '/api/servicios/terminales/',
        ofertaPath: '/api/atenciones/oferta/',
        atencionPath: '/api/atenciones/entradas/',
        installmentsPath: '/api/servicios/installments-tariff/',
        generarPdfPath: '/api/utils/generate-oferta-pdf/',
        installmentSpecificPath: '/api/servicios/installments/',
        clientesPath: '/api/clientes/entradas/',
    }
})

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
    selectedSVAs: (state, _unused, getters, rootState) => {
        let svas

        try {
            svas = state.atencion.oferta.paquetes.find(({ tipoLinea }) => tipoLinea == 'LINEA_PRINCIPAL').svas
        } catch {
            svas = []
        }
        return svas
    },
    mainLine: (state) => {
        let paquete
        try {
            paquete = state.atencion.oferta.paquetes.find(({ tipoLinea }) => tipoLinea == 'LINEA_PRINCIPAL')
        } catch {
            paquete = clone(defaultPaqueteForm)
        }

        if (!paquete) {
            paquete = clone(defaultPaqueteForm)
        }
        paquete.tipoLinea = 'LINEA_PRINCIPAL'

        return paquete
    },
    additionalPackages: (state) => (
        state.atencion.oferta.paquetes.filter(({ tipoLinea }) => tipoLinea == 'LINEA_ADICIONAL')
    ),
    iva: (state) => {
        let iva
        if (state.selectedLocation) {
            iva = 1 + parseFloat(state.selectedLocation.encoded) / 100
        } else {
            iva = 1
        }

        return iva
    },
    paquetePrice: (state, getters) => (paquete) => {
        paquete = objectCamelToSnakeCase(paquete)

        let price = 0

        if (paquete.tarifa) {
            price = parseFloat(paquete.tarifa.price)
        }

        // Distinguir si es una tarifa segmento negocios o no
        if (state.isp && state.isp.segment == 'PARTICULAR') {
            price *= getters.iva
        }

        if (paquete.tarifa && paquete.promotion) {
            if (state.configuratorType == 'EDIT' && paquete.promotion_priority) {
                // let promocion_tarifas = paquete.promotion_priority.filter(({ promotion }) => {
                //     return paquete.tarifa.promotions.some((promocion) => (
                //         promocion.id == promotion.id
                //     ))
                // })

                paquete.promotion_priority.sort(function (a, b) {
                    if (a.priority_order < b.priority_order) return -1;
                    if (a.priority_order > b.priority_order) return 1;
                    return 0;
                });

                paquete.promotion_priority.forEach(promotion => {
                    if (promotion.promotion && promotion.promotion.amount_unit == 'MONETARY') {
                        price -= parseFloat(promotion.promotion.amount)
                    } else if (promotion.promotion && promotion.promotion.amount_unit == 'PERCENTS') {
                        price = price * (1 - promotion.promotion.amount * 0.01)
                    }
                })

            } else {
                // Obtener solo las promociones asociadas a tarifas, descartar las de los sva, no hace falta
                // let promocion_tarifas = paquete.promotion.filter(({ id }) => {
                //     return paquete.tarifa.promotions.some((promotion) => (
                //         promotion.id == id
                //     ))
                // })

                paquete.promotion.forEach(promotion => {
                    if (promotion && promotion.amount_unit == 'MONETARY') {
                        price -= parseFloat(promotion.amount)
                    } else if (promotion && promotion.amount_unit == 'PERCENTS') {
                        price = price * (1 - promotion.amount * 0.01)
                    }
                })
            }
        }

        if (state.isp && state.isp.segment == 'NEGOCIOS') {
            price *= getters.iva
        }

        if (paquete.cacharro) {
            if (paquete.installment)
                price += parseFloat(paquete.installment.month_price ? paquete.installment.month_price : 0)
            else
                price += 0//parseFloat(paquete.cacharro.price)

            // Nuevo cuidado!!!
            // price += (parseFloat(terminalPrice))
            if (paquete.seguro) {
                price += parseFloat(paquete.seguro.price) * getters.iva
            }
        }

        return price
    },
    totalPrice: (state, getters) => {
        let price = 0
        state.atencion.oferta.paquetes.forEach(paquete => {
            price += getters.paquetePrice(paquete)
        })

        return price.toFixed(2)
    },
    clienteId: () => {
        return router.currentRoute.params.id
    }
}

const mutations = {
    numeroComercial: (state, val) => {
        state.numeroComercial = val;
    },
    operador: (state, val) => {
        state.operador = val;
    },
    stepperType: (state, val) => {
        switch (val) {
            case 'main':
                state.paquete = getters.mainLine(state)
                state.paquete.tipoLinea = 'LINEA_PRINCIPAL'
                break
            default:
                state.paquete = clone(defaultPaqueteForm)
                state.paquete.tipoLinea = 'LINEA_ADICIONAL'
                break
        }
    },
    localizacion: (state, val) => {
        state.localizacion = val;
    },
    commercialPhonenumber: (state, val) => {
        state.commercialPhonenumber = val;
    },
    isp: (state, val) => {
        state.isp = val;
    },
    isOpenConfiguratorStepper: (state, val) => {
        state.isOpenConfiguratorStepper = val;
    },
    isOpenPresetDialog: (state, val) => {
        state.isOpenPresetDialog = val;
    },
    presetPhoneNumbers: (state, val) => {
        state.presetPhoneNumbers = val;
    },
    presetMainUsed: (state, val) => {
        state.presetMainUsed = val;
    },
    isOpenAditionalStepper: (state, val) => {
        state.isOpenAditionalStepper = val;
    },
    hasAdditionals: (state, val) => {
        state.hasAdditionals = val;
    },
    totalSVA: (state, val) => {
        state.totalSVA = val;
    },
    numFibraFijo: (state, val) => {
        state.numFibraFijo = val;
    },
    numAdicionales: (state, val) => {
        state.numAdicionales = val;
    },
    totalPrice: (state, val) => {
        state.totalPrice = val;
    },
    precioMensOtro: (state, val) => {
        state.precioMensOtro = val;
    },
    precioActualYG: (state, val) => {
        state.precioActualYG = val;
    },
    cuotaTerminales: (state, val) => {
        state.cuotaTerminales = val;
    },
    loadingTariffs: (state, val) => {
        state.loadingTariffs = val;
    },
    selectedLocation: (state, val) => {
        state.selectedLocation = val;
    },
    package: (state, val) => {
        if (!val) {
            if (state.atencion.oferta.paquetes.length > 0 && state.paquete.tipoLinea == "LINEA_PRINCIPAL") {
                state.atencion.oferta.paquetes.splice(state.atencion.oferta.paquetes.indexOf(state.atencion.oferta.paquetes.find((paquete) => paquete.tipoLinea == 'LINEA_PRINCIPAL')), 1)
            }

            state.atencion.oferta.paquetes = [...state.atencion.oferta.paquetes, clone(state.paquete)]
            state.paquete = clone(defaultPaqueteForm)
        } else {
            state.atencion.oferta.paquetes = [...state.atencion.oferta.paquetes, clone(val)]
        }
    },

    packagesPop: (state, val) => {
        let index = state.atencion.oferta.paquetes.indexOf(val)
        if (index != -1) state.atencion.oferta.paquetes.splice(index, 1)
    },
    additionals: (state, val) => {
        state.additionals = clone(val)
    },
    tariffs: (state, val) => {
        state.tariffs = clone(val)
    },
    terminals: (state, val) => {
        state.terminals = clone(val)
    },
    promotions: (state, val) => {
        state.promotions = clone(val)
    },
    options: (state, val) => {
        state.options = clone(val)
    },
    installments: (state, val) => {
        state.installments = clone(val)
    },
    installmentsLoading: (state, val) => {
        state.installmentsLoading = val
    },
    svas: (state, val) => {
        state.svas = val
    },
    cliente: (state, val) => {
        state.cliente = objectSnakeToCamelCase(val)
    },
    atencion: (state, val) => {
        state.atencion = clone(val)
    },
    paquete: (state, val) => {
        state.paquete = clone(val)
    },
    configuratorType: (state, val) => {
        state.configuratorType = val
    },
    comercial: (state, val) => {
        state.atencion.comercial = clone(val)
    },
    canSaveOffer: (state, val) => {
        state.canSaveOffer = val
    },
    isLoadingCliente: (state, val) => {
        state.isLoadingCliente = val
    },
}

const actions = {
    packagesDuplicate({ commit, state }, paquete) {
        let index = state.atencion.oferta.paquetes.indexOf(paquete)

        if (index != -1) {
            // console.log(state.atencion.oferta.paquetes[index])
            let newPackage = clone(state.atencion.oferta.paquetes[index])
            newPackage.lineasAsociadas = []
            commit('package', newPackage)
        }
    },
    async saveEditedOffer({ commit, state, getters, dispatch }) {
        try {
            commit('canSaveOffer', false)

            state.atencion.oferta.tipoIva = state.selectedLocation.encoded
            state.atencion.oferta.precioAnterior = state.precioMensOtro
            state.atencion.oferta.precioTotal = getters.totalPrice
            state.atencion.oferta.isp = state.isp.isp
            state.atencion.oferta.numeroComercial = state.numeroComercial


            // Filter linea principal
            let lineasAsociadasPrincipal = state.atencion.oferta.paquetes.find(({ tipoLinea }) => tipoLinea == 'LINEA_PRINCIPAL')
            if (lineasAsociadasPrincipal) {
                state.atencion.oferta.paquetes.forEach(paquete => {
                    if (paquete.tipoLinea == 'LINEA_ADICIONAL_SVA') {
                        paquete.lineasAsociadas = lineasAsociadasPrincipal.lineasAsociadas.length ? [lineasAsociadasPrincipal.lineasAsociadas[0]] : []
                    }
                })
            }

            if (state.atencion.notas && state.atencion.notas != '') {
                state.atencion.oferta['notas'] = state.atencion.notas
            }

            if (state.atencion.cliente.direccion) {
                if (state.atencion.cliente.direccion.direccion?.trim() == "")
                    state.atencion.cliente.direccion.direccion = null
                if (state.atencion.cliente.direccion.cp?.trim() == "")
                    state.atencion.cliente.direccion.cp = null
                if (state.atencion.cliente.direccion.localidad?.trim() == "")
                    state.atencion.cliente.direccion.localidad = null
            }

            // state.atencion.oferta.paquetes = clone(state.atencion.oferta.paquetes = state.atencion.oferta.paquetes.filter(paquete => Boolean(paquete.tarifa)))

            await axios.put(getters.getEndpointFromPath(state.paths.ofertaPath) + state.atencion.oferta.id + "/",
                objectCamelToSnakeCase(
                    deleteKeyNullValues(
                        clone(state.atencion.oferta)
                    )
                )
            )

            let offerPhoneNumbers = []

            state.atencion.oferta.paquetes.forEach(paquete => {
                offerPhoneNumbers = [...offerPhoneNumbers, ...paquete.lineasAsociadas]
            });

            offerPhoneNumbers.forEach((phoneNumber) => {
                if (!state.cliente.telefonosContacto.some((another) => another == phoneNumber))
                    state.cliente.telefonosContacto.push(phoneNumber)
            })


            let encoded_form = objectCamelToSnakeCase(state.cliente)

            try {
                await axios.put(getters.getEndpointFromPath(state.paths.clientesPath) + state.cliente.id + '/', encoded_form)
            } catch (error) {
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    error: error,
                    timeout: 8000,
                    message: 'Error al actualizar datos de cliente'
                }, { root: true })
            }

            setTimeout(() => {
                dispatch('util/showStatusSnackBar', {
                    statusType: 'success',
                    message: 'Oferta editada correctamente'
                }, { root: true }).then(() => {
                    commit('canSaveOffer', true)
                }).catch(() => {
                    commit('canSaveOffer', true)
                })
            }, 4000)

            setTimeout(() => {
                router.push({
                    name: 'calculadora',
                }),
                    commit('configuratorType', 'CREATE')
                commit('canSaveOffer', true)
            }, 2000)
        }
        catch (error) {
            commit('canSaveOffer', true)

            if (error.config?.url.includes(state.paths.clientesPath)) {
                state.cliente.telefonosContacto.forEach((telefono) => {
                    if (readError.readError(error).message.includes(telefono))
                        state.cliente.telefonosContacto.splice(state.cliente.telefonosContacto.indexOf(telefono), 1)
                })
            }

            dispatch('util/showStatusSnackBar', {
                error: error,
                timeout: 4000,
                statusType: 'error',
                message: 'Hubo un error al editar'
            }, { root: true })
        }
    },
    initialiseEditing({ commit, dispatch, rootState }, item) {
        let atencion = {
            comercial: item.comercial,
            fechaContacto: item.servicio.atencion.fechaContacto,
            estado: item.servicio.estado,
            cliente: item.cliente,
            notas: item.notas,
            oferta: null
        }

        // Para guardar el iva en el selector
        commit('selectedLocation', JSON.parse(localStorage.getItem('opciones')).oferta.ubicacion.find(({ encoded }) => encoded == item.servicio.tipoIva))
        atencion.oferta = {
            id: item.servicio.id,
            fechaAgendado: null,
            isp: item.servicio.atencion.isp,
            razonNoInteresado: '',
            tipoIva: item.servicio.tipoIva,
            precioAnterior: item.servicio.atencion.precioAnterior,
            precioTotal: item.servicio.atencion.precioTotal,
            paquetes: item.servicio.paquetes,
            numeroComercial: item.servicio.numeroComercial
        }


        // Comprobamos si es una oferta con solo SVAS
        let isOnlySVAOffer = atencion.oferta.paquetes.some(paquete => (
            paquete.tipoLinea == 'LINEA_ADICIONAL_SVA'
        ))

        // Si sólo tenemos SVAS en esta oferta necesitamos añadir un paquete "fantasma" para que se muestre la parte de abajo
        if (isOnlySVAOffer) {
            let paquete = clone(defaultPaqueteForm)
            paquete.lineasAsociadas = atencion.oferta.paquetes.find(({ tipoLinea }) => tipoLinea == 'LINEA_ADICIONAL_SVA').lineasAsociadas
            paquete.tipoLinea = 'LINEA_PRINCIPAL'
            atencion.oferta.paquetes.push(paquete)
        }

        let isp = {
            segment: item.servicio.paquetes[0].tarifa ? item.servicio.paquetes[0].tarifa.segment : item.cliente.segmento && item.cliente.segmento != 'Particular' ? 'NEGOCIOS' : 'PARTICULAR',
            isp: item.servicio.paquetes[0].tarifa ? item.servicio.paquetes[0].tarifa.operator : item.cliente.isp_actual
        }

        // fix bug ya se pondra mejor
        if (isp.isp == 'DBL') {
            isp.segment = 'NEGOCIOS'
        }

        commit('configuratorType', 'EDIT')
        commit('numeroComercial', item.servicio.numeroComercial)
        commit('isp', isp)
        commit('operador', item.isp)
        commit('atencion', atencion)
        commit('cliente', item.cliente)
        dispatch('getTerminals')
        dispatch('getTariffs')
        dispatch('getAdditionals')
    },
    reset({ commit, state }) {
        return new Promise((resolve, reject) => {
            let oldOfferId = state.atencion.oferta.id
            try {
                commit('presetMainUsed', false)
                commit('atencion', clone(defaultAtencionOfertaForm))
                state.atencion.oferta.id = oldOfferId
                commit('paquete', clone(defaultPaqueteForm))
                state.atencion.cliente = state.cliente
                resolve()
            } catch {
                reject()
            }
        })
    },
    async getAdditionals({ getters, state, commit }) {
        state.loadingTariffs = true
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.additionalsPath), {
            params: {
                default: 1,
                is_active: 1,
                operator: state.isp.isp,
                segment: state.isp.segment
            },
        })

        commit('additionals', resp.data.results)
        state.loadingTariffs = false
    },
    async getTariffs({ getters, state, commit }) {
        state.loadingTariffs = true
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.tariffsPath), {
            params: {
                default: 1,
                is_active: 1,
                operator: state.isp.isp,
                segment: state.isp.segment
            },
        })

        commit('tariffs', resp.data.results)
        state.loadingTariffs = false
    },
    async getTerminals({ getters, state, commit }) {
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.terminalsPath), {
            params: {
                is_active: 1,
                operator: state.isp.isp == 'DBL' ? 'YOIGO' : state.isp.isp
            },
        })

        commit('terminals', resp.data.results)
    },
    async fetchSpecificInstallments({ getters, state }, { idTarifa, idCacharro }) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.installmentSpecificPath) + `${idTarifa}/${idCacharro}`)
            return resp.data[0]
        } catch (error) {
            // console.log(error)
        }
    },
    async getPromotions({ getters, state, commit }) {
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.promotionsPath), {
            params: {
                default: 1,
                is_active: 1
            }
        })

        commit('promotions', resp.data.results)
    },
    async getSVA({ getters, state, commit }) {
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.svaPath), {
            params: {
                default: 1,
                is_active: 1
            }
        })
        commit('svas', resp.data.results)
    },
    async getInstallments({ getters, state, commit }, { installment_type, tarifa }) {
        commit('installmentsLoading', true)
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.installmentsPath) + tarifa.id + '/' + installment_type)
        commit('installmentsLoading', false)

        commit('installments', resp.data)
    },
    async guardarOferta({ commit, state, getters, dispatch }) {
        try {
            commit('canSaveOffer', false)
            state.atencion.oferta.tipoIva = state.selectedLocation.encoded
            state.atencion.oferta.precioAnterior = state.precioMensOtro
            state.atencion.oferta.precioTotal = getters.totalPrice
            state.atencion.oferta.isp = state.isp.isp
            state.atencion.oferta.numeroComercial = state.numeroComercial

            if (state.atencion.cliente.direccion) {
                if (state.atencion.cliente.direccion.direccion?.trim() == "")
                    state.atencion.cliente.direccion.direccion = null
                if (state.atencion.cliente.direccion.cp?.trim() == "")
                    state.atencion.cliente.direccion.cp = null
                if (state.atencion.cliente.direccion.localidad?.trim() == "")
                    state.atencion.cliente.direccion.localidad = null
            }
            console.log(state.atencion.oferta.paquetes)

            state.atencion.oferta.paquetes = clone(state.atencion.oferta.paquetes = state.atencion.oferta.paquetes.filter(paquete => Boolean(paquete.tarifa)))

            await axios.post(getters.getEndpointFromPath(state.paths.atencionPath),
                objectCamelToSnakeCase(
                    deleteKeyNullValues(
                        clone(state.atencion)
                    )
                )
            )

            let offerPhoneNumbers = []

            state.atencion.oferta.paquetes.forEach(paquete => {
                offerPhoneNumbers = [...offerPhoneNumbers, ...paquete.lineasAsociadas]
            });

            offerPhoneNumbers.forEach((phoneNumber) => {
                if (!state.cliente.telefonosContacto.some((another) => another == phoneNumber))
                    state.cliente.telefonosContacto.push(phoneNumber)
            })

            let encoded_form = objectCamelToSnakeCase(state.cliente)

            try {
                // await axios.put(getters.getEndpointFromPath(state.paths.clientesPath) + state.cliente.id + '/', encoded_form)
            } catch (error) {
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    error: error,
                    timeout: 8000,
                    message: 'Error al actualizar datos de cliente'
                }, { root: true })
            }

            setTimeout(() => {
                dispatch('util/showStatusSnackBar', {
                    statusType: 'success',
                    message: 'Oferta guardada correctamente'
                }, { root: true }).then(() => {
                    commit('canSaveOffer', true)
                }).catch(() => {
                    commit('canSaveOffer', true)
                })
            }, 4000)

            setTimeout(() => {
                router.push({
                    name: 'teletrabajo',
                }).then(() => {
                    commit('teletrabajo/IsOpenCompleteViewTtFormDialog', true, { root: true })
                    dispatch('teletrabajo/fetchTtClienteHistoricoFromOferta', {}, { root: true })
                    commit('canSaveOffer', true)
                })
            }, 1000)
        } catch (error) {
            commit('canSaveOffer', true)
            if (error.config.url.includes(state.paths.clientesPath)) {
                state.cliente.telefonosContacto.forEach((telefono) => {
                    if (readError.readError(error).message.includes(telefono))
                        state.cliente.telefonosContacto.splice(state.cliente.telefonosContacto.indexOf(telefono), 1)
                })
            }

            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                error: error,
                timeout: 8000,
                message: 'Error al guardar oferta'
            }, { root: true })

        }
    },
    async getCliente({ state, getters, commit }, id) {
        commit('isLoadingCliente', true)
        let resp = await axios.get(getters.getEndpointFromPath(state.paths.clientesPath) + id)
        if (resp.data.last_atencion) {
            delete resp.data.last_atencion
        }
        commit('cliente', resp.data)
        state.atencion.cliente = state.cliente
        setTimeout(() => {
            commit('isLoadingCliente', false)
        }, 500)
    },
    async descargarPdfOferta({ state, getters }) {
        let pdfHtmlString = generarHtmlOferta()
        try {
            let resp = await axios.post(getters.getEndpointFromPath(state.paths.generarPdfPath), {
                html: pdfHtmlString
            })
            const blob = new Blob([resp.data],
                { type: 'application/pdf' })
            let fileURL = window.URL.createObjectURL(blob)
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', 'OFERTIVIRI.pdf')
            document.body.appendChild(fileLink)

            fileLink.click();
            document.body.removeChild(fileLink); // Download complete remove element
            window.URL.revokeObjectURL(fileURL) // Release blob object
        } catch {

        }
    },
    init({ dispatch, rootState, commit, state }) {
        let tenant = JSON.parse(
            localStorage.getItem('tenantInfo')
        ).name;

        if (state.configuratorType == 'CREATE')
            return Promise.all((() => {
                let actions = [
                    // dispatch('getOptions'),
                    commit('isp', tenant != 'avatel' ? {
                        url: '/yoigo.png',
                        alt: 'YOIGOPARTICULAR',
                        segment: 'PARTICULAR',
                        isp: 'YOIGO',
                    } : {
                        url: '/avatel.png',
                        alt: 'AVATELPARTICULAR',
                        segment: 'PARTICULAR',
                        isp: 'AVATEL',
                    },
                    ),
                    commit('canSaveOffer', true),
                    dispatch('getTariffs'),
                    dispatch('getAdditionals'),
                    dispatch('getPromotions'),
                    // dispatch('util/fetchTenantInfo', null, { root: true }),
                    // dispatch('getSVA'),
                    dispatch('getTerminals'),
                ]

                if (localStorage.getItem('opciones') == null) {
                    actions.push(dispatch('util/fetchOpciones', null, { root: true }))
                }

                return actions
            })())
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}